const firebaseConfig = {
    apiKey: "AIzaSyBGXdYHEJ10OiHMsW1JlMuKWA5Y2rYL1mc",
    authDomain: "child-day-care.firebaseapp.com",
    projectId: "child-day-care",
    storageBucket: "child-day-care.appspot.com",
    messagingSenderId: "267807662552",
    appId: "1:267807662552:web:ac48223576f4b3f10452ad"
  };
  export default firebaseConfig;